import IncubatorDistributor from './IncubatorDistributor';

export default IncubatorDistributor;